import React from 'react';
import { ApInput, ApRadio } from '@alixpartners/ui-components';

import { UNIT_MAP } from 'utils/number';

import {
	Wrapper,
	Title,
	Description,
	RadioWrapper,
	InputWrapper,
	PercentageInput,
	TailSpendValueInput,
	TailSpendVendorsInput,
} from './TailSpendThreshold.styles';

export const TAIL_SPEND_TYPES = {
	percentage: 0,
	value: 1,
	quantity: 2,
	vendorSpend: 3,
};

export const TailSpendThreshold = ({
	tailSpendType,
	tailSpend,
	previewData,
	onChange,
	currencySymbol,
	unit,
}) => {
	const unitRatio = UNIT_MAP[unit] || UNIT_MAP.m;

	const onTailSpendInputChange = value => {
		let parsedValue = parseFloat(value);

		if (
			tailSpendType === TAIL_SPEND_TYPES.vendorSpend ||
			tailSpendType === TAIL_SPEND_TYPES.value
		) {
			parsedValue = parsedValue * unitRatio;
		}

		const tailSpend = !Number.isNaN(parsedValue) ? parsedValue : '';

		onChange({ tailSpend });
	};

	const onTailSpendTypeChange = e => {
		const tailSpendType = parseInt(e.target.value, 10);
		let tailSpend = 0;

		if (previewData) {
			const tailSpendValueByType = [
				previewData.harmonized.tailSpendPercentage,
				previewData.harmonized.tailSpendValue,
				previewData.harmonized.tailVendorsCount,
				0,
			];
			tailSpend = tailSpendValueByType[tailSpendType];
		}

		onChange({
			tailSpendType,
			tailSpend,
		});
	};

	return (
		<Wrapper>
			<Title>Threshold</Title>
			<Description>
				Select the method for allocating vendors to tail spend
			</Description>
			<RadioWrapper>
				<ApRadio
					name="tail_spend"
					key={TAIL_SPEND_TYPES.vendorSpend}
					value={TAIL_SPEND_TYPES.vendorSpend}
					checked={tailSpendType === TAIL_SPEND_TYPES.vendorSpend}
					onChange={onTailSpendTypeChange}
				>
					<InputWrapper>
						<TailSpendVendorsInput
							type="number"
							name="vendorSpend"
							className="threshold-field"
							disabled={tailSpendType !== TAIL_SPEND_TYPES.vendorSpend}
							placeholder={
								tailSpendType !== TAIL_SPEND_TYPES.vendorSpend ? 'Auto' : ''
							}
							value={
								tailSpendType !== TAIL_SPEND_TYPES.vendorSpend
									? ''
									: Math.round(tailSpend) / unitRatio
							}
							onChange={onTailSpendInputChange}
							symbol={`${currencySymbol}${unit &&
								unit.toUpperCase()} per vendor`}
							shouldStopPropagation
						/>
					</InputWrapper>
				</ApRadio>
				<ApRadio
					name="tail_spend"
					key={TAIL_SPEND_TYPES.percentage}
					value={TAIL_SPEND_TYPES.percentage}
					checked={tailSpendType === TAIL_SPEND_TYPES.percentage}
					onChange={onTailSpendTypeChange}
				>
					<InputWrapper>
						<PercentageInput
							name="percentage"
							min={1}
							max={99}
							className="threshold-field"
							disabled={tailSpendType !== TAIL_SPEND_TYPES.percentage}
							placeholder={
								tailSpendType !== TAIL_SPEND_TYPES.percentage ? 'Auto' : ''
							}
							value={
								tailSpendType !== TAIL_SPEND_TYPES.percentage ? '' : tailSpend
							}
							onChange={onTailSpendInputChange}
							symbol="% spend"
							shouldStopPropagation
						/>
					</InputWrapper>
				</ApRadio>
				<ApRadio
					name="tail_spend"
					key={TAIL_SPEND_TYPES.value}
					value={TAIL_SPEND_TYPES.value}
					checked={tailSpendType === TAIL_SPEND_TYPES.value}
					onChange={onTailSpendTypeChange}
				>
					<InputWrapper>
						<ApInput
							type="number"
							name="value"
							className="threshold-field"
							disabled={tailSpendType !== TAIL_SPEND_TYPES.value}
							placeholder={
								tailSpendType !== TAIL_SPEND_TYPES.value ? 'Auto' : ''
							}
							value={
								tailSpendType !== TAIL_SPEND_TYPES.value
									? ''
									: tailSpend / unitRatio
							}
							onChange={onTailSpendInputChange}
							symbol={`${currencySymbol}M`}
							shouldStopPropagation
						/>
					</InputWrapper>
				</ApRadio>
				<ApRadio
					name="tail_spend"
					key={TAIL_SPEND_TYPES.quantity}
					value={TAIL_SPEND_TYPES.quantity}
					checked={tailSpendType === TAIL_SPEND_TYPES.quantity}
					onChange={onTailSpendTypeChange}
				>
					<InputWrapper>
						<TailSpendValueInput
							type="number"
							className="threshold-field"
							name="quantity"
							disabled={tailSpendType !== TAIL_SPEND_TYPES.quantity}
							placeholder={
								tailSpendType !== TAIL_SPEND_TYPES.quantity ? 'Auto' : ''
							}
							value={
								tailSpendType !== TAIL_SPEND_TYPES.quantity ? '' : tailSpend
							}
							onChange={onTailSpendInputChange}
							symbol="vendors"
							shouldStopPropagation
						/>
					</InputWrapper>
				</ApRadio>
			</RadioWrapper>
		</Wrapper>
	);
};

export default TailSpendThreshold;
